// removed by extract-text-webpack-plugin
module.exports = {"badgeStyle":"_3sZXDodFs41corkEql0XZi"};


//////////////////
// WEBPACK FOOTER
// ../components/badge/styles.module.css
// module id = 591
// module chunks = 0